"use client";

import { useReportWebVitals } from "next/web-vitals";

export function WebVitals() {
  useReportWebVitals((metric) => {
    const { name, value, rating } = metric;

    const color =
      rating === "good"
        ? "\x1b[32m"
        : rating === "needs-improvement"
          ? "\x1b[33m"
          : "\x1b[31m";

    console.log(
      `${color}[Web Vital] ${name}: ${Math.round(value)}ms (${rating})\x1b[0m`
    );
  });

  return null;
}
